package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccab.casr.EngineIdentifiers
import com.neurobs.react.{GenericState, GenericStateGenerator, StyleUtil}
import com.neurobs.ccabserver.transcriptreview.util.{EditableTranscriptWord, NonEditableTranscript, NonEditableTranscriptWord}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

case class EngineWordState
(
	transcript: NonEditableTranscript,
	word: NonEditableTranscriptWord,
	recordingState: RecordingTranscriptReviewState,
	testState: TestTranscriptReviewState
) extends GenericState {

	import EngineWordState._

	def displayConfidence = transcript.engineIdentifier == EngineIdentifiers.CASR

	def generateStyle = StyleUtil.makeStyle(
		("marginLeft", recordingState.calculateLeftMargin(word, transcript, testState.PPS) + "px"),
		("width", testState.secondsToPixels(word.duration) + "px"),
		("cursor", "pointer"),
		("position", "relative"),
		("height", "20px")
	)

	def correspondingReviewWord: Option[EditableTranscriptWord] = {
		recordingState.handler.findOverlappingWord(word, MIN_CORRESPONDENCE_OVERLAP_FRACTION)
	}

	def handleMouseEnter(): Unit = {
		correspondingReviewWord.map(recordingState.setHighlightedWord(_))
	}

	def handleMouseOut(): Unit = {
		recordingState.clearHighlightedWord()
	}

	def handleClick(): Unit = {
		correspondingReviewWord.map(correspondingReviewWord => {
			correspondingReviewWord.word = word.word
		})

		correspondingReviewWord match {
			case None => recordingState.handler.addWord(EditableTranscriptWord(word))
			case Some(correspondingReviewWord) =>
				correspondingReviewWord.word = word.word
		}
		testState.registerChange()
	}
}

object EngineWordState {

	val MIN_CORRESPONDENCE_OVERLAP_FRACTION = .7
}

object EngineWordStateGenerator extends GenericStateGenerator[EngineWordState] {

	override def generateEmptyDefaultState(): EngineWordState = {
		EngineWordState(
			NonEditableTranscript("", Seq()),
			NonEditableTranscriptWord(),
			RecordingTranscriptReviewStateGenerator.generateEmptyDefaultState(),
			TestTranscriptReviewStateGenerator.generateEmptyDefaultState()
		)
	}
}

@react
object EngineWordStateProvider {

	case class Props(transcript: NonEditableTranscript, word: NonEditableTranscriptWord, recordingState: RecordingTranscriptReviewState, testState: TestTranscriptReviewState, children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>

		val engineWordState = EngineWordState(
			props.transcript,
			props.word,
			props.recordingState,
			props.testState
		)

		EngineWordStateGenerator.Provider(engineWordState)(
			props.children:_*
		)
	}
}
